export default "__VITE_ASSET__XfsRx68j__"